export const disclosuresDev = {
  batsSubscriberAgreement: 'https://legal.drivewealth.com/bats-subscriber-agreement?lang=en_US',
  cashManagementProgramDisclosure: 'https://legal.drivewealth.com/cash-management-program-disclosure-statement',
  customerAccountAgreement: 'https://legal.drivewealth.com/customer-account-agreement',
  marginAgreement: 'https://legal.drivewealth.com/margin-risk-disclosure-statement',
  nasdaqSubscriberAgreement: 'https://legal.drivewealth.com/nasdaq-subscriber-agreement?lang=en_US',
  nyseAmexSubscriberAgreement: 'https://legal.drivewealth.com/nyse-amex-subscriber-agreement?lang=en_US',
  privacyPolicy: 'https://legal.drivewealth.com/privacy-policy',
  rule14b: '',
  termsOfUse: 'https://legal.drivewealth.com/terms-of-use',
  tradingDisclosure: 'https://legal.drivewealth.com/fractional-shares-disclosure',
  advWrapFeeDisclosure: 'https://support.wealth-eg-dev.com/hc/en-us/articles/30874586279700',
  customerRelationshipSummaryDisclosure: 'https://support.wealth-eg-dev.com/hc/en-us/articles/30874628076820',
  iraCustomerAccountAgreement:
    'https://docs.drivewealth.com/hubfs/IRA%20Custodial%20Account%20Agreement%20&%20Disclosure%20Statement%20with%20Custodian%20Approval%20Letter%20(2022.06.28).pdf',
}
